import CalendarWithTime from "@/components/DateTimePicker/CalendarWithTime/calendarWithTime.component";
import { Button } from "@/shadcn/components/ui/button";
import { PopoverContent } from "@/shadcn/components/ui/popover";
import { formatDueDate } from "@/utils/utils";
import { Popover, PopoverTrigger } from "@radix-ui/react-popover";
import { CalendarIcon } from "lucide-react";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";

type DateTimePickerProps = {
  dateTime: Date | null | undefined;
  onDateTimeChange: (date: Date | undefined | null) => void;
  setDateTime?: Dispatch<SetStateAction<Date | null | undefined>>;
  modal: boolean;
  createDateTimeOpen?: React.MutableRefObject<boolean>;
  showTriggerTime?: boolean;
  showTriggerSeconds?: boolean;
};

const DateTimePicker: React.FC<DateTimePickerProps> = ({
  dateTime,
  onDateTimeChange,
  setDateTime,
  modal,
  createDateTimeOpen,
  showTriggerTime = false,
  showTriggerSeconds = false,
}) => {
  const [isDateTimePickerOpen, setIsDateTimePickerOpen] = useState(false);

  const handleFieldDateTime = (date: Date | undefined | null) => {
    if (setDateTime) {
      setDateTime(date);
    }
    onDateTimeChange(date);
    setIsDateTimePickerOpen(false);
  };

  useEffect(() => {
    if (createDateTimeOpen) {
      createDateTimeOpen.current = isDateTimePickerOpen;
    }
  }, [isDateTimePickerOpen, createDateTimeOpen]);

  // useEffect(() => {
  //   console.log("isDateTimePickerOpen", isDateTimePickerOpen);
  // }, [isDateTimePickerOpen]);

  return (
    <Popover
      modal={modal}
      open={isDateTimePickerOpen}
      onOpenChange={setIsDateTimePickerOpen}
    >
      <PopoverTrigger asChild>
        <Button
          id="edit-due-date"
          variant="outline"
          className={`w-full justify-start text-left font-normal ${
            !dateTime && "text-muted-foreground"
          }`}
          onMouseDown={(e) => {
            e.stopPropagation();
          }}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {dateTime ? (
            formatDueDate(dateTime, showTriggerTime, showTriggerSeconds)
          ) : (
            <span>Pick a date</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="w-auto p-0"
        onMouseDown={(e) => e.stopPropagation()}
      >
        {isDateTimePickerOpen && (
          <CalendarWithTime
            dateTime={dateTime}
            onDateTimeChange={handleFieldDateTime}
          />
        )}
      </PopoverContent>
    </Popover>
  );
};

export default DateTimePicker;
